import React from 'react';
import {connect} from 'react-redux';

import {changeOpacity} from '../../actionCreators';

const OpacitySlider = ({height, opacity, onChange}) => (
    <div className="opacity-slider" style={{height, display: height < 60 ? 'none' : 'block'}}>
        <input
            type="range"
            value={opacity * 100}
            onChange={onChange}
            style={{width: height}}
        />
    </div>
);

const mapStateToProps = ({OSMOpacity}) => ({opacity: OSMOpacity});

const mapDispatchToProps = dispatch => ({
    onChange: ({target}) => dispatch(changeOpacity(target.value / 100)),
});

export default connect(mapStateToProps, mapDispatchToProps)(OpacitySlider);
